import React from "react";
import { Badge, Box, Tab, Tabs } from "@mui/material";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import BlockIcon from "@mui/icons-material/Block";
import PaidIcon from "@mui/icons-material/Paid";
import { TABS_PEDIDOS } from "../config/estadosPedido";

const ICONOS_TAB = {
  pendientes: HourglassEmptyIcon,
  asignados: LocalShippingIcon,
  anulados: BlockIcon,
  pendientesFacturacion: PaidIcon,
};

// Reemplaza los tabs planos originales: agrega ícono por estado y muestra
// la cantidad de pedidos de la pestaña activa (y, siempre, la cantidad
// pendiente de facturación, que es el único contador que provee el backend
// de forma independiente a la pestaña seleccionada).
const NavegacionTabs = ({ activeTab, onChange, cantidadActiva, contadorFacturacion, esMobile }) => (
  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
    <Tabs
      value={activeTab}
      onChange={(event, next) => onChange(next)}
      variant={esMobile ? "scrollable" : "fullWidth"}
      scrollButtons={esMobile ? "auto" : false}
      allowScrollButtonsMobile
    >
      {TABS_PEDIDOS.map(({ index, key, label }) => {
        const Icono = ICONOS_TAB[key];
        const esActiva = activeTab === index;
        const badge = key === "pendientesFacturacion" ? (esActiva ? cantidadActiva : contadorFacturacion) : esActiva ? cantidadActiva : 0;
        return (
          <Tab
            key={key}
            icon={<Icono fontSize="small" />}
            iconPosition="start"
            label={
              <Badge
                badgeContent={badge}
                color={key === "pendientesFacturacion" ? "error" : "primary"}
                showZero={key === "pendientesFacturacion"}
                sx={{ "& .MuiBadge-badge": { right: -12, top: -2 } }}
              >
                <Box sx={{ pr: badge ? 1 : 0 }}>{label}</Box>
              </Badge>
            }
          />
        );
      })}
    </Tabs>
  </Box>
);

export default NavegacionTabs;
